import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getRelatedJobAds = async (companyID, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });

  const {
    data: { data: jobAds, total },
  } = await axios.get(`/api/companies/${companyID}/job_ads?${queryString}`);

  return { jobAds, total };
};

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  includeInactive: false,
  acceptingOffers: false,
  sortBy: 'dateCreated',
  queryKey: ['companies-related-job-ads'],
  queryOptions: {},
};

export const useGetRelatedJobAds = (companyID, queryParams = {}) => {
  const { page, limit, search, includeInactive, acceptingOffers, sortBy, queryKey, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    search,
    includeinactive: includeInactive,
    includexpired: !acceptingOffers,
    sortby: sortBy,
    offset: page * limit,
  };

  return useQuery(
    [...queryKey, companyID],
    () => getRelatedJobAds(companyID, queryStringParams),
    {
      select: ({ jobAds, total }) => ({ jobAds, total }),
      initialData: { jobAds: [], total: 0 },
      ...queryOptions,
    }
  );
}